

export default class CompanyPriorities {

    public priority1    : string    = '1'
    public priority2    : string    = '2'
    public priority3    : string    = '3'
    public priority4    : string    = '4'
    public priority5    : string    = '5'
    public priority6    : string    = '6'
    public priority7    : string    = '7'
    public priority8    : string    = '8'
    public priority9    : string    = '9'
    public priority10   : string    = '10'
    public priority50   : string    = '50'
    public priority100  : string    = '100'

    constructor() {
    }

    exportToOptions():Option[] {

        const options : Option[] = []

        if (this.priority100)   options.push({ value: 100,  label: this.priority100,    color: 100 });
        if (this.priority50)    options.push({ value: 50,   label: this.priority50,     color: 50 });
        if (this.priority10)    options.push({ value: 10,   label: this.priority10,     color: 10 });
        if (this.priority9)     options.push({ value: 9,    label: this.priority9,      color: 9 });
        if (this.priority8)     options.push({ value: 8,    label: this.priority8,      color: 8 });
        if (this.priority7)     options.push({ value: 7,    label: this.priority7,      color: 7 });
        if (this.priority6)     options.push({ value: 6,    label: this.priority6,      color: 6 });
        if (this.priority5)     options.push({ value: 5,    label: this.priority5,      color: 5 });
        if (this.priority4)     options.push({ value: 4,    label: this.priority4,      color: 4 });
        if (this.priority3)     options.push({ value: 3,    label: this.priority3,      color: 3 });
        if (this.priority2)     options.push({ value: 2,    label: this.priority2,      color: 2 });
        if (this.priority1)     options.push({ value: 1,    label: this.priority1,      color: 1 });

        return options;
    }

    getName(priority:number,showNumberIfNoValue?:boolean):string {
        // @ts-ignore
        if (this['priority'+priority]) {
            // @ts-ignore
            return this['priority'+priority];
        }

        if (showNumberIfNoValue===true)
            return priority.toString()


        return ''
    }

    setName(priority:number,name:string) {

        // @ts-ignore
        this['priority'+priority] = name;
    }

    getValueByName(name:string):number | false {

        const values = [1,2,3,4,5,6,7,8,9,10,50,100]
        let result : any = false

        values.map((value:number)=>{
            // @ts-ignore
            if (this["priority"+value.toString()] && this["priority"+value.toString()].toLowerCase()===name.toLowerCase()) {
                result = value;
            }
        });

        return result;
    }

}

